import { defineStore } from 'pinia'
import type {  Cart, EmptyCart } from '~/types'

const defaultCart: EmptyCart = {
  id: 0,
  customer_id: null,
  items: [],
  itemCount: 0,
  subtotal: 0,
  discountTotal: 0,
  taxTotal: 0,
  deliveryTotal: 0,
  total: 0,
  currency: ''
}

export const useCartStore = defineStore('cart', () => {
  const data = ref<Cart | EmptyCart>(defaultCart)

  const pending = ref(true)

  const catalogService = useCatalogService()

  async function loadCart() {
    try {
      pending.value = true
      data.value = await catalogService.getCart().then(response => response.data)
    } catch (error) {
      console.error('Error loading cart:', error)
    } finally {
      pending.value = false
    }
  }

  async function addProduct({ productId, quantity = 1, variantId }: { productId: number; quantity?: number; variantId: number }) {
    data.value = await catalogService.addCartProduct({ productId, quantity, variantId }).then(response => response.data)
  }

  async function removeItem(productId: number) {
    data.value = await catalogService.removeCartItem(productId).then(response => response.data)
  }

  async function clearCart() {
    data.value = await catalogService.clearCart().then(response => response.data)
  }

  async function updateItemQuantity(itemId: number, quantity: number) {
    data.value = await catalogService.updateCartItemQuantity(itemId, quantity).then(response => response.data)
  }

  async function getProductVariantItem(productId: number) {
    return data.value.items.find(item => item.productId === productId)?.id
  }

  return { 
    data,
    addProduct,
    getProductVariantItem,
    pending,
    removeItem,
    loadCart,
    clearCart,
    updateItemQuantity
  }
})
